export default __webpack_public_path__ + "static/media/620.2ed35063.png";